<template>
    <div class="text-center">
        <h2 class="mt-3 text-center">Mobile Fitting</h2>
        <p class="text-center">What do you require help with?</p>
    
        <div class="accordion accordion-flush" id="CSAccordion" ref="csParent">
            <div class="accordion-section">
                <div class="accordion-item" v-for="faq in faqs">
                    <h2 class="accordion-header" :id="'heading' + faq.id">
                        <button class="accordion-button collapsed mb-2 text-center" :class="accordionBg" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse' + faq.id" aria-expanded="false" :aria-controls="'#collapse' + faq.id">
                            {{ faq.question }}
                        </button>
                    </h2>
                    <div :id="'collapse' + faq.id" class="accordion-collapse collapse" :aria-labelledby="'heading' + faq.id" data-bs-parent="#CSAccordion">
                        <div class="accordion-body">
                            <div v-html="faq.answer"></div>
                        </div>
                    </div>
                </div>
            </div>
            <p v-if="faqs.length == 0" class="text-center">There are no FAQ's available, please check again later.</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['customerServiceNumber', 'faqs', 'accordionBg']
    }
</script>

<style lang="scss" scoped>

</style>